import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <div className="logo">
            <img 
              src="https://whales.market/icons/logo_v2.svg" 
              alt="Whales Market" 
              className="logo-icon"
            />
          </div>
        </div>
        
        <nav className="header-nav">
          <button className="nav-item active">Premarket</button>
          <button className="nav-item">Dashboard</button>
          <button className="nav-item">About</button>
          <div className="nav-dropdown">
            <button className="nav-item">Earn ▼</button>
          </div>
        </nav>
        
        <div className="header-right">
          <button className="connect-button">Connect</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
